import * as React from "react";
import { MyCard } from "../MyCard";
import { IBalanceProps, formatNumber } from "./Address";

export function Balance({ balance, baseCurrency }: IBalanceProps) {
  const balanceAmount = balance / 100000000;
  return (
    <MyCard
      header={"Balance · " + (baseCurrency || "TLS")}
      body={formatNumber(balanceAmount)}
    />
  );
}
